import React from 'react';
import { useLocation } from 'react-router-dom';  // Import useLocation
import { Box, Typography, Button } from '@mui/material';
import PublishCard from '../components/PublishCard';
import { useNavigate } from 'react-router-dom';

const PublishPage = () => {
  const location = useLocation();
  const { selectedImages, mockupResponseData, finalList } = location.state || {};

  return (
    <Box sx={{ textAlign: 'left' }}>
      <h1>Publish</h1>
      <PublishCard
        selectedMockups={selectedImages}
        mockupResponseData={mockupResponseData}
        finalDescription={finalList}
      />
    </Box>
  );
};

export default PublishPage;